/* global exports */
"use strict";
import Modal from "bootstrap/js/dist/modal";
import * as modalUtils from "../../client/js/utils/modal.ts";

const progressDOMel = document.getElementById("progress");

/**
 * Init progress modal only once
 */
function initModal() {
  if (progressDOMel) {
    if (!Modal.getInstance(progressDOMel)) {
      new Modal(progressDOMel, {
        keyboard: false,
        backdrop: "static",
      });
    }

    progressDOMel.addEventListener("show.bs.modal", () => {
      const progressBar = document.querySelector("#progress .progress-bar");

      progressBar
        ?.animate([{ width: "0%" }, { width: "100%" }], {
          duration: 3000,
          easing: "ease",
          fill: "forwards",
        })
        .finished.then(() => modalUtils.hideModalBs5(progressDOMel));
    });
  }
}

export function showProgress(msg) {
  return function () {
    initModal();
    const message = document.querySelector("#progress .progress-message");

    if (message) {
      message.innerText = msg;
    }

    modalUtils.showModalBs5(progressDOMel);
  };
}

export function hideProgress() {
  modalUtils.hideModalBs5(progressDOMel);
}
